const text = (value, fallback) => String(value || "").trim() || fallback;

/** Stable client-only namespace for unsent, sanitised editor drafts. */
export function composerDraftKey({ kind = "message", role = "unknown", userId = "guest", conversationId = "thread" } = {}) {
  const scope = kind === "fola" ? "fola" : "message";
  return `${scope}:${text(role, "unknown")}:${text(userId, "guest")}:${text(conversationId, "thread")}`;
}

export function richMessageDraftStorageKey(draftStorageKey = "") {
  return `afrimed:message-draft:${String(draftStorageKey || "").trim()}`;
}

export function clearRichMessageDraft(draftStorageKey = "", storage = globalThis?.window?.localStorage) {
  const key = String(draftStorageKey || "").trim();
  if (!key || !storage) return;
  try { storage.removeItem(richMessageDraftStorageKey(key)); } catch {}
}
